import React from 'react';
import { Text } from '@bloobirds-it/flamingo-ui';
import styles from './emptyCard.module.css';

const EmptyContactTaskCard = ({ children }) => (
  <div className={styles._card}>
    <Text color="softPeanut" align="center">
      {children}
    </Text>
  </div>
);

export default EmptyContactTaskCard;
